module.exports = __webpack_public_path__ + "static/media/signage.8ea65073.svg";